import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Feedback = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M22.962,43.371l-4.394,-8.4l-8.163,0c-3.467,0 -6.287,-3.06 -6.405,-6.779l0,-17.225c0.119,-3.803 2.939,-6.867 6.019,-6.967l27.19,0c3.755,0.109 6.786,3.225 6.791,6.981l0,17.225c-0.119,3.7 -2.938,6.764 -6.4,6.764l-8.169,0l-4.394,8.4c-0.201,0.387 -0.602,0.63 -1.038,0.63c-0.435,0 -0.836,-0.243 -1.037,-0.63l0,0.001Zm-16.5,-32.446l0,17.225c-0.132,2.304 1.641,4.314 3.943,4.469l8.871,0c0.435,0 0.836,0.243 1.038,0.629l3.686,7.046l3.686,-7.046c0.202,-0.386 0.603,-0.629 1.038,-0.629l8.876,0c2.302,-0.156 4.074,-2.165 3.942,-4.469l0,-17.225c0.133,-2.303 -1.64,-4.313 -3.942,-4.469l-27.195,0c-2.302,0.156 -4.076,2.166 -3.943,4.469Zm17.028,15.03c-1.14,-0.622 -2.228,-1.336 -3.252,-2.135c-2.336,-1.839 -3.515,-3.634 -3.5,-5.335c0.003,-2.37 1.955,-4.318 4.325,-4.318c1.106,0 2.172,0.424 2.975,1.185c1.697,-1.608 4.406,-1.566 6.052,0.094c0.808,0.81 1.258,1.911 1.247,3.054c-0.012,1.694 -1.2,3.483 -3.518,5.318c-1.018,0.798 -2.1,1.512 -3.234,2.134c-0.344,0.183 -0.756,0.183 -1.1,0l0.005,0.003Zm-4.412,-7.455c-0.012,1.692 3.038,3.956 4.951,5.072c0.821,-0.485 1.61,-1.023 2.361,-1.612c1.648,-1.306 2.6,-2.573 2.6,-3.475c0.004,-0.52 -0.201,-1.02 -0.569,-1.388c-0.373,-0.376 -0.882,-0.588 -1.411,-0.588c-0.84,0 -1.592,0.532 -1.873,1.322c-0.166,0.467 -0.61,0.78 -1.104,0.78c-0.495,0 -0.939,-0.313 -1.105,-0.78c-0.279,-0.791 -1.031,-1.323 -1.87,-1.323c-1.088,0 -1.983,0.895 -1.983,1.983c0,0.004 0,0.007 0,0.01l0.003,-0.001Z" fill={fill} />
    </svg>
  );
};

Feedback.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Feedback.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
